import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type GetReleaseStatusResponse = {
  state: number;
  value: [];
};

export const getReleaseStatusList = async (): Promise<[]> => {
  try {
    const res = await apiClient.post<GetReleaseStatusResponse>(
      Endpoints.ContenedorStatus,
      {}
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
